import React from 'react';
import { Star } from 'lucide-react';

const OurClientsSection = () => {
  const clients = [
    {
      name: 'Glossyra Naturals',
      logo: '/client-logos/glossyra.png',
      alt: 'Glossyra Naturals Logo'
    },
    {
      name: 'Luxoree',
      logo: '/client-logos/luxoree.png',
      alt: 'Luxoree Logo'
    },
    {
      name: 'KS International Real Estate',
      logo: '/client-logos/ks-international.png',
      alt: 'KS International Real Estate Logo'
    },
    {
      name: 'Wow Farm House',
      logo: '/client-logos/wow-farm-house.png',
      alt: 'Wow Farm House Logo'
    }
  ];

  return (
    <section id="solutions" style={{ background: 'var(--bg-page)', padding: '7rem 1.5rem 5rem' }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '3rem', maxWidth: '700px', margin: '0 auto 3rem' }}>
          <h2 className="heading-2" style={{ marginBottom: '1rem' }}>
            Our Clients
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Trusted by businesses across industries to deliver exceptional digital solutions
          </p>
        </div>

        {/* Client Logos Grid */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem', marginBottom: '4rem' }}>
          {clients.map((client, index) => (
            <div
              key={index}
              style={{
                background: 'var(--bg-card)',
                border: '1px solid var(--border-light)',
                borderRadius: '12px',
                padding: '2.5rem',
                textAlign: 'center',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                cursor: 'default',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '180px'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              {/* Client Logo */}
              <div
                style={{
                  background: '#adb9ca',
                  padding: '1rem',
                  borderRadius: '8px',
                  width: '200px',
                  height: '150px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <img
                  src={client.logo}
                  alt={client.alt}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    width: 'auto',
                    height: 'auto',
                    objectFit: 'contain'
                  }}
                />
              </div>
            </div>
          ))}
        </div>

        {/* Trust Stats */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '2rem', marginBottom: '4rem', background: 'var(--bg-section)', padding: '2rem', borderRadius: '12px' }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2.5rem', fontWeight: '700', color: 'var(--accent-text)', marginBottom: '0.5rem' }}>
              10+
            </div>
            <div className="body-medium" style={{ color: 'var(--text-secondary)' }}>
              Happy Clients
            </div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2.5rem', fontWeight: '700', color: 'var(--accent-text)', marginBottom: '0.5rem' }}>
              100%
            </div>
            <div className="body-medium" style={{ color: 'var(--text-secondary)' }}>
              Client Satisfaction
            </div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2.5rem', fontWeight: '700', color: 'var(--accent-text)', marginBottom: '0.5rem' }}>
              24/7
            </div>
            <div className="body-medium" style={{ color: 'var(--text-secondary)' }}>
              Support Available
            </div>
          </div>
        </div>

        {/* Client Testimonial */}
        <div
          style={{
            background: 'var(--bg-card)',
            border: '1px solid var(--border-light)',
            borderRadius: '12px',
            padding: '3rem',
            textAlign: 'center',
            maxWidth: '800px',
            margin: '0 auto'
          }}
        >
          <div style={{ marginBottom: '1.5rem' }}>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '0.25rem', marginBottom: '1rem' }}>
              {[1, 2, 3, 4, 5].map((star) => (
                <Star key={star} size={24} fill="var(--accent-primary)" color="var(--accent-primary)" />
              ))}
            </div>
          </div>
          <p className="body-large" style={{ marginBottom: '1.5rem', fontStyle: 'italic', color: 'var(--text-body)' }}>
            "ibTECON transformed our online presence with their innovative approach to digital marketing. Their team's expertise in AI-driven solutions helped us reach our target audience more effectively than ever before."
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
            <div className="body-small" style={{ color: 'var(--text-secondary)' }}>CEO, KAS International</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurClientsSection;